// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__19Oc0","main":"style_main__2j5t8","buttons":"style_buttons__2M42k","save":"style_save__g-MHp"};